import(/* webpackMode: "eager" */ "/vercel/path0/components/Home.js")